import { InstitutionsServicesApi } from "@/features/institutions/services/institutions-services-api";
import { InstitutionsServicesGetRequestModel } from "@/features/institutions/services/institutions-services-model";

/// 金融機関サービス一覧取得画面処理
export class InstitutionsServicesService {
  private institutionsServicesApi = new InstitutionsServicesApi();

  /**
   * 金融機関サービス一覧取得API実行
   */
  public async getInstitutionsServices(param: InstitutionsServicesGetRequestModel) {
    return await this.institutionsServicesApi.getInstitutionsServices(param);
  }
}

